import { fetchUser } from "@/services/user";
import { isSetAndNotEmpty } from "@/utils/helpers";

export const hasRequiredMembershipAgreementInfo = (
  customer: Awaited<ReturnType<typeof fetchUser>>,
) => {
  return (
    isSetAndNotEmpty(customer.first_name) &&
    isSetAndNotEmpty(customer.last_name) &&
    isSetAndNotEmpty(customer.dob) &&
    isSetAndNotEmpty(customer.mobile_phone)
  );
};
